import { render, staticRenderFns } from "./Fines.vue?vue&type=template&id=51106e6e&scoped=true"
import script from "./Fines.vue?vue&type=script&lang=js"
export * from "./Fines.vue?vue&type=script&lang=js"
import style0 from "./Fines.vue?vue&type=style&index=0&id=51106e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51106e6e",
  null
  
)

export default component.exports